import { AxiosError } from 'axios';
import { POST_RETRIEVE_SCHOOL_CANDIDATE_PAYMENT_DETAILS } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../../api';

export interface SchoolCandidatePaymentExamLevelFeeModel {
  examLevel: string;
  outstandingAmount: string;
}

export interface SchoolCandidatePaymentDetailsResponse {
  uuid: string;
  name: string;
  examYear: number;
  examLevelsFeeModels: SchoolCandidatePaymentExamLevelFeeModel[];
  totalPayable: string;
}

export interface SchoolCandidatePaymentDetailsRequest {
  idType: 'NRIC_OR_FIN' | 'PASSPORT';
  uinFinPassport: string;
  schoolUuid: string;
  examYear: number;
  email: string;
}

interface Input {
  onSuccess?: () => void;
  onError?: (e: AxiosError<GenericErrorResponse>) => void;
}

export const usePostRetrieveSchoolCandidatePaymentDetails = ({ onSuccess, onError }: Input) => {
  const postRetrieveSchoolCandidatePaymentDetails = async (
    payload: SchoolCandidatePaymentDetailsRequest
  ) => {
    const res = await axiosClient.post<SchoolCandidatePaymentDetailsResponse>(
      POST_RETRIEVE_SCHOOL_CANDIDATE_PAYMENT_DETAILS,
      payload
    );

    return res.data;
  };

  return useCustomMutation(
    postRetrieveSchoolCandidatePaymentDetails,
    {
      onSuccess,
      onError,
    },
    false,
    false
  );
};
